import { Typography } from "@mui/material";
import { MuiTelInput, MuiTelInputCountry } from "mui-tel-input";

export const PHONE_COUNTRY_OPTIONS: MuiTelInputCountry[] = [
  "US",
  "CA",
  "DO",
  "DE",
];

interface IViewFieldProps {
  mode: "view";
  value: string;
  label: string;
}

interface IEditFieldProps {
  mode: "edit" | "add";
  value: string;
  label: string;
  onChange: (value: string) => void;
  error?: boolean;
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

type ViewOrEditPhoneFieldProps = IViewFieldProps | IEditFieldProps;

const ViewOrEditPhoneField = (props: ViewOrEditPhoneFieldProps) => {
  if (props.mode === "view") {
    return (
      <>
        <Typography variant="h6">{props.label}</Typography>
        <Typography variant="body1">{props.value || "-"}</Typography>
      </>
    );
  }

  return (
    <MuiTelInput
      label={props.label}
      value={props.value}
      onChange={props.onChange}
      error={props.error}
      fullWidth
      margin="normal"
      variant="outlined"
      required={props.required}
      disabled={props.disabled}
      autoFocus={props.autoFocus}
      onKeyDown={props.onKeyDown}
      onlyCountries={PHONE_COUNTRY_OPTIONS}
      defaultCountry="US"
      forceCallingCode
      focusOnSelectCountry
    />
  );
};

export default ViewOrEditPhoneField;
